import { render, staticRenderFns } from "./BuyIn.vue?vue&type=template&id=1de4c188&scoped=true&"
import script from "./BuyIn.vue?vue&type=script&lang=ts&"
export * from "./BuyIn.vue?vue&type=script&lang=ts&"
import style0 from "./BuyIn.vue?vue&type=style&index=0&id=1de4c188&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de4c188",
  null
  
)

export default component.exports